// Generated by CoffeeScript 1.12.7
(function() {
  var VASTAd;

  VASTAd = (function() {
    function VASTAd() {
      this.id = null;
      this.sequence = null;
      this.system = null;
      this.title = null;
      this.description = null;
      this.advertiser = null;
      this.pricing = null;
      this.survey = null;
      this.errorURLTemplates = [];
      this.impressionURLTemplates = [];
      this.creatives = [];
      this.extensions = [];
    }

    return VASTAd;

  })();

  module.exports = VASTAd;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/vast-client/dist/ad.js
// module id = 63
// module chunks = 0